import type { ReactNode, Ref } from "react";
import { AppHeader } from "./AppHeader";
import type { AppHeaderProps } from "./AppHeader";

interface AppContainerProps extends AppHeaderProps {
  className?: string;
  contentClassName?: string;
  containerRef?: Ref<HTMLElement>;
  fixedContent?: ReactNode;
  afterContent?: ReactNode;
  children: ReactNode;
}

export function AppContainer({
  className = "",
  contentClassName = "",
  containerRef,
  fixedContent,
  afterContent,
  children,
  ...headerProps
}: AppContainerProps) {
  return (
    <main ref={containerRef} className={`${className} app-container`.trim()}>
      <AppHeader {...headerProps} />
      {fixedContent}
      <div className={`app-scroll ${contentClassName}`.trim()}>{children}</div>
      {afterContent}
    </main>
  );
}
